import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
} from "@mui/material";
import typography from "../../../cssUtils/typography";
import { CallingCodeSelect } from "../../../common/country-code-select";
import { getCallingCodePhoneError } from "../../../common/phone-validation";
import { useTenantCountryDefault } from "../../../hooks/useTenantCountry";

const SingleContact = (props) => {
  const {
    setCountryCode,
    setDialCode,
    setName,
    // Add these props to receive current values from parent
    nameValue = "",
    countryCodeValue = "",
    phoneNumberValue = "",
  } = props;

  // Initialize local state from parent values
  const [singleContactCountryCode, setSingleContactCountryCode] =
    useState(countryCodeValue);
  const [phoneNumberSuffix, setPhoneNumberSuffix] = useState(phoneNumberValue);
  const [name, setNameLocal] = useState(nameValue);

  const [nameError, setNameError] = useState("");

    console.log("isEditMode in SingleContact:", props?.isEditMode);
  // Add effect to sync parent values to local state
  useEffect(() => {
    setNameLocal(nameValue);
    setSingleContactCountryCode(countryCodeValue);
    setPhoneNumberSuffix(phoneNumberValue);

    // Reset error states when form is cleared
    if (!nameValue && !countryCodeValue && !phoneNumberValue) {
      setNameError("");
    }
  }, [nameValue, countryCodeValue, phoneNumberValue]);

  // New contacts start on the tenant's country (Tenant Settings) until the user picks another
  useTenantCountryDefault(countryCodeValue, setCountryCode, { enabled: !props?.isEditMode });

  // The parent keeps exactly what was entered (it checks the number before sending),
  // so changing the country never wipes a typed number
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhoneNumberSuffix(value);
    setDialCode(value);
  };

  // Handle first name changes and update parent component state
  const handleFirstNameChange = (e) => {
    const inputValue = e.target.value;

    setNameLocal(inputValue);
    setName(inputValue);
  };

  console.log("isEditMode in SingleContact:", props?.isEditMode);

  const handleCountryCodeSelect = (value) => {
    setSingleContactCountryCode(value);
    setCountryCode(value);
  };

  // Typed number is checked live against the selected country
  const phoneError = phoneNumberSuffix
    ? getCallingCodePhoneError(phoneNumberSuffix, singleContactCountryCode)
    : null;

  return (
    <>
      {/* First Name and Last Name Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ ...typography.h2, mt: 1, mb: 1 }}>
            Contact Information
          </Typography>
        </Grid>
        <Grid item xs={12}>

          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={name}
            onChange={handleFirstNameChange}
            required
            error={nameError !== ""}
            helperText={nameError}
            disabled={props?.isEditMode}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
      </Grid>

      {/* Original Phone Number Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={3} md={4}>
          <FormControl fullWidth>
            <CallingCodeSelect
              value={singleContactCountryCode}
              onChange={handleCountryCodeSelect}
              required
              disabled={props?.isEditMode}
              TextFieldProps={{
                InputLabelProps: { sx: typography.bodyLarge },
                sx: {
                  '& .MuiOutlinedInput-root': { borderRadius: '8px', ...typography.bodyLarge },
                  '& fieldset': { borderColor: '#DFE5EC' },
                },
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={9} md={8}>

          <TextField
            fullWidth
            id="outlined-basic"
            label="Phone Number"
            variant="outlined"
            value={phoneNumberSuffix}
            onChange={handlePhoneNumberChange}
            required
            disabled={props?.isEditMode}
            error={Boolean(phoneError)}
            helperText={phoneError}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            FormHelperTextProps={{ sx: typography.bodySmall }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SingleContact;
